import { render } from "./DistributorsView.vue?vue&type=template&id=c93b455e&ts=true"
import script from "./DistributorsView.vue?vue&type=script&lang=ts"
export * from "./DistributorsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__